import { render, staticRenderFns } from "./WhatsappProductShare.vue?vue&type=template&id=0032d3ea"
import script from "./WhatsappProductShare.vue?vue&type=script&lang=js"
export * from "./WhatsappProductShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports